import { CheckboxProps } from './Checkbox';

export const useCheckbox = ({
  id,
  displayLabel,
  displayLabelSize = 'normal',
  showBorderBox = true,
  noHover = false,
  onChange,
  ...rest
}: CheckboxProps) => {
  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(id, event.target.checked);
  };

  const labelStyle = {
    fontSize:
      displayLabelSize === 'small' ? '12px' : displayLabelSize === 'medium' ? '14px' : '16px',
    color: rest.disabled ? '#d3d4d7' : '#333',
    cursor: rest.disabled ? 'default' : 'pointer',
  };

  return {
    onChangeHandler,
    labelStyle,
    id,
    displayLabel,
    showBorderBox,
    noHover,
    ...rest,
  };
};
